import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=5125afbf&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=5125afbf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5125afbf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5125afbf')) {
      api.createRecord('5125afbf', component.options)
    } else {
      api.reload('5125afbf', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=5125afbf&scoped=true&", function () {
      api.rerender('5125afbf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2uAtIBOO0Bat4/JS/comp/PopupDialog.vue"
export default component.exports